import { render, staticRenderFns } from "./StudentActions.vue?vue&type=template&id=0090a4eb&scoped=true"
import script from "./StudentActions.vue?vue&type=script&lang=js"
export * from "./StudentActions.vue?vue&type=script&lang=js"
import style0 from "./StudentActions.vue?vue&type=style&index=0&id=0090a4eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090a4eb",
  null
  
)

export default component.exports